'use client'

import { motion, useReducedMotion } from 'framer-motion'
import { cn } from '@/lib/utils'

/**
 * Three dots while an AI Coworker is composing an answer (plan 06 AskBar and
 * the AI Manager). Announced once through `label`; the dots are decorative.
 * With reduced motion the dots hold still.
 */
export function TypingDots({
  label = 'Thinking',
  className,
}: {
  label?: string
  className?: string
}) {
  const reduced = useReducedMotion()
  return (
    <span role='status' className={cn('inline-flex items-center gap-1', className)}>
      <span className='sr-only'>{label}</span>
      {[0, 1, 2].map((dot) => (
        <motion.span
          key={dot}
          aria-hidden='true'
          className='h-1.5 w-1.5 rounded-full bg-brand-cornflower'
          animate={reduced ? undefined : { opacity: [0.3, 1, 0.3], y: [0, -2, 0] }}
          transition={reduced ? undefined : { repeat: Infinity, duration: 0.9, delay: dot * 0.15 }}
        />
      ))}
    </span>
  )
}
